import { Controller } from "@hotwired/stimulus";

// The home hero's "Commencez avec" cards fill the prompt textarea above when clicked — a small
// enhancement over a plain <form>. The form itself needs NO JavaScript to work: it always
// navigates to the real signup page on submit (same "connexion/inscription" landing every other
// anonymous entry point on the site already uses). Server-rendered on purpose, not a client-only
// mount: the prompt box and the cards must be visible even before this controller connects — a
// broken/late JS bundle must not blank out the top of the home page.
export default class extends Controller {
  static targets = ["textarea", "composer"];

  declare readonly textareaTarget: HTMLTextAreaElement;
  declare readonly hasTextareaTarget: boolean;
  declare readonly composerTarget: HTMLElement;
  declare readonly hasComposerTarget: boolean;

  fill(event: Event) {
    const button = event.currentTarget as HTMLElement;
    const prompt = button.dataset.prompt;
    if (!prompt || !this.hasTextareaTarget) return;

    this.textareaTarget.value = prompt;
    this.textareaTarget.focus();
    this.revealComposer();
  }

  // Only moves the page when it has to. The header is `sticky top-0` — a plain
  // `scrollIntoView({ block: "start" })` aligns the composer's top edge with the viewport's own
  // top, which is exactly where the header sits, so the freshly-filled prompt lands hidden
  // behind it. If the composer is already fully visible below the header, this does nothing at
  // all — no anchor jump for a click that didn't need one.
  revealComposer() {
    if (!this.hasComposerTarget) return;

    const header = document.querySelector("header");
    const headerHeight = header ? header.getBoundingClientRect().height : 0;
    const rect = this.composerTarget.getBoundingClientRect();

    if (rect.top >= headerHeight) return;

    const gap = 16;
    window.scrollTo({ top: window.scrollY + rect.top - headerHeight - gap, behavior: "smooth" });
  }
}
